<div class="timepicker-container">
  <app-search-bar-input
          [id]="'timepicker-item-' + id"
          [isMobile]="isMobile"
          [searchType]="searchType"
          [label]="label"
          [placeholder]="placeholder"
          [value]="value"
          [icon]="icons.ChevronFilledDown"
          [swapPlaceholder]="swapLabel"
          [readOnly]="true"
          [showError]="showError"
          (isFocus)="toggle(true)"
          [disabled]="disabled">
  </app-search-bar-input>

  <ng-template #timepickerContent>
    <div class="timepicker-content" #timepickerMatrix>
      <div class="timepicker-selector">
        <app-ds-data-picker
          [data]="dataPickerModel"
          (changedEvent)="updateTime($event)">
        </app-ds-data-picker>
      </div>
    </div>
  </ng-template>

  <ng-container *ngIf="isMobile">
    <app-swipe-up
      [height]="maxHeight"
      [showSwipeUp]="show"
      [showHeader]="true"
      [title]="title"
      [showFooter]="true"
      (toggleShowSwipeUp)="toggle()">
      <ng-container content *ngIf="show">
        <ng-container *ngTemplateOutlet="timepickerContent"></ng-container>
      </ng-container>
      <app-ds-button footer
        [labels]="{ ButtonLabel: 'AUTOS_MODULE.SEARCH.TIME_APPLY' | transloco }"
        (clickEvent)="applyTime()">
      </app-ds-button>
    </app-swipe-up>
  </ng-container>
</div>
